import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
export const temuRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Temu" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hideHeader={() => true} /> };
    },
    children: [
      {
        path: "callback",
        async lazy() {
          const { TemuCallback } = await import("./callback");
          return { Component: TemuCallback };
        },
      },
    ],
  },
];
